export default "__VITE_PUBLIC_ASSET__cad45605__"